import { useMemo } from 'react';
import * as yup from 'yup';
import yupResolver from '@wix/da-shared-react/pkg/utils/yupResolver';
import { SubmitFormValues } from '../redux/types';

export function useSubmitValidationResolver(
  validationSchema?: yup.ObjectSchema
) {
  return useMemo(
    () =>
      validationSchema
        ? yupResolver<SubmitFormValues>(validationSchema, {
            abortEarly: false,
          })
        : undefined,
    [validationSchema]
  );
}
